import { createSlice } from '@reduxjs/toolkit';

import { logger } from 'src/utils/serverLogger';
import { adaptPartnerContentToStore } from './adapters/adaptPartnerContentToStore';
import { adaptPartnerInsightsForStore } from './adapters/adaptPartnerInsightsForStore';
import { requestPartnerContent, requestPartnerInsights } from './thunks';
import type { PartnerState } from './types';

export type { PartnerState } from './types';

export const initialState: PartnerState = {
  content: undefined,
  insights: undefined,
};

const partnerSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestPartnerContent.fulfilled, (state, { payload }) => {
        state.content = payload ? adaptPartnerContentToStore(payload) : null;
      })
      .addCase(requestPartnerContent.rejected, (state, action) => {
        logger.error('Error requesting partner content', action.error);
        state.content = null;
      })
      .addCase(requestPartnerInsights.fulfilled, (state, { payload }) => {
        state.insights = payload ? adaptPartnerInsightsForStore(payload) : null;
      })
      .addCase(requestPartnerInsights.rejected, (state, action) => {
        logger.error('Error requesting partner insights', action.error);
        state.insights = null;
      });
  },
});

export const { reducer } = partnerSlice;
